
import { SymbolData } from '../types';

export const doorsData: SymbolData[] = [
  {
    id: 'door-xiu',
    char: '休',
    pinyin: 'Xiū Mén',
    summary: '休门：静水流深',
    tags: ['休止', '休闲', '属水', '流动'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203183319.png',
    story: '一位刚办理完退休手续的人，忽然觉得整个人"松"了下来——工作彻底休止。他把衣柜里最宽松的衬衫换上，决定去海边做一次彻底的休闲调养：早晨在疗养院慢慢散步，午后泡一壶茶，晚上做理疗按摩。为了到达海滨，他先买了一张火车票，一路在车厢里听着风扇转动的声音，看窗外河流与雨丝不断后退；等车到站，他又换乘小车去码头，眼前水景开阔，心也跟着"水"一样变得温顺而平静——这就是休门的"静水流深"。',
    coreOrigins: [
      {
        title: '核心原点 ①：休止 → 静止、终结与倦怠',
        logic: '“休”的根本是停止运动，这引申出一切静止、懒散、无活力的状态，直至生命的最终休止——死亡。',
        subItems: [
          { label: '概念', content: '停止、终结、死亡、倦怠、无活力、懒散（无关好坏）。' },
          { label: '人物', content: '懒散之人、睡觉者、离退休者、死人。' },
          { label: '性情', content: '慢、无精打采、不慌不忙、缺乏动力。' },
          { label: '形态', content: '半睁眼、动作迟缓、姿态松垮。' },
        ],
      },
      {
        title: '核心原点 ②：休闲 → 调理、放松与安逸',
        logic: '从“休止”中引申出积极的一面，即主动的休整与放松，代表着对身心的调理和享受安逸的生活品质。',
        subItems: [
          { label: '概念', content: '休养生息、休闲、放松、调理、整理、美容、美发、修理。' },
          { label: '人物', content: '品质高贵之人（安然不争）、美容美发师、修理工、营养师、护士、护理人员、清闲之人、白领。' },
          { label: '形态', content: '气质好、语音偏低、语速偏慢、着装宽松休闲。' },
          { label: '性情', content: '温顺安然、漫不经心、随和不争。' },
          { label: '地理', content: '广场、公园、酒吧、娱乐厅、ktv、名人居所、卧室、床、客厅、疗养院。' },
          { label: '天时', content: '星期天、节假日。' },
        ],
      },
      {
        title: '核心原点 ③：属水 → 液体、松软与温顺',
        logic: '休门五行为水，其物理形态表现为液体或吸水后松软的物质；其性情则表现为水的滋润与温顺。',
        subItems: [
          { label: '静物', content: '饮料、酒、油、盐、酱油、醋、调料、水、油器、汽油、煤油、柴油、润滑油；布匹、绳索、衣物、棉花海绵。' },
          { label: '动物', content: '金鱼、毛虫、蜗牛、水牛、黄牛（温顺、动作缓慢）。' },
          { label: '植物', content: '水草、白菜、青菜、萝卜、芹菜、黄瓜、西瓜（含水量大）。' },
          { label: '人体', content: '生殖系统、泌尿系统、循环系统（体液系统）。' },
          { label: '方位/色彩', content: '北方；蓝色、黑色；冬天。' },
        ],
      },
      {
        title: '核心原点 ④：流动 → 旅游、运输与载具',
        logic: '水的另一大特性是流动，这引申出旅游、运输等概念，以及实现这些流动的载具和场所。',
        subItems: [
          { label: '概念', content: '旅游、运输、移动、行走、过渡、流转。' },
          { label: '静物', content: '船、汽车、火车、自行车、电瓶车、摩托车；钟表、风扇、洗衣机、空调（内部流动）。' },
          { label: '地理', content: '水池、水景、河流、海滨、车站、码头。' },
          { label: '天时', content: '雨天。' },
        ],
      },
    ],
  },
  {
    id: 'door-sheng',
    char: '生',
    pinyin: 'Shēng Mén',
    summary: '生门：大地之利',
    tags: ['生活', '生长', '生产', '利润'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203183609.png',
    story: '清晨，雾气笼着东北方向的田野，一位做农产品生意的老板站在自家农场门口，先检查仓库里的种子、肥料与工具——这些都是他赖以生活与维持经营的根基。随后他走进地里，看着幼苗从泥土里一寸寸探头、叶片舒展，心里明白"生门之生"首先是万物生长的力量：只要土壤、营养和水分到位，生命就会继续延伸。到了中午，他打开账本核对订单，安排工人采摘、分拣、打包、发货，把地里的生机转成车间的生产与市场的交易；傍晚结算回款时，他看到利润数字稳稳增长——这份"大地之利"，就是生门在现实里最直接的回馈。',
    coreOrigins: [
      {
        title: '核心原点 ①：生活 → 根基、环境与所需',
        logic: '“生”首先是生活与生存，它代表着我们赖以生存的物质基础、环境和生活必需品。',
        subItems: [
          { label: '概念', content: '生活、生存、根基、依靠、靠山、衣食住行所需。' },
          { label: '静物', content: '日常必需品、粮食、器具、生活用品。' },
          { label: '地理', content: '住宅（阳宅风水关乎赚钱）、客厅、房屋、桥梁、街道、公园、居住社区。' },
          { label: '方位/色彩', content: '东北；云、雾、阴天；黄色。' },
        ],
      },
      {
        title: '核心原点 ②：生长 → 生命、活力与延续',
        logic: '“生”是生长与生机，代表着生命力本身，以及万物从无到有、从小到大的发展过程。',
        subItems: [
          { label: '概念', content: '延续、生机、生长、发展、孕育、活着。' },
          { label: '人物', content: '学生（知识在生长）、孕妇（生命在生长）、培育者、照料者。' },
          { label: '形态', content: '方脸、厚唇、鼻子方直，神态乐观向上。' },
          { label: '性情', content: '忠厚守时、诚恳稳重、乐观踏实。' },
          { label: '人体', content: '鼻、嘴、胃、脾、肠（与营养生长相关）。' },
          { label: '动植物', content: '泛指一切动物；泛指一切植物。' },
        ],
      },
      {
        title: '核心原点 ③：生产 → 工作、经营与利润',
        logic: '“生”最终体现为生产活动，即通过工作和经营创造价值，从而获取利润和效益。',
        subItems: [
          { label: '概念', content: '工作、学习、经商、生意、生产、效益、利润、利息（投资要看）。' },
          { label: '人物', content: '劳动者、生意人、金融机构从业者、经理人、管理者、领导者。' },
          { label: '性情', content: '有经济头脑、务实能干、重结果。' },
          { label: '地理', content: '工厂、农场、渔场；商店、销售部、交易市场。' },
        ],
      },
    ],
  },
  {
    id: 'door-shang',
    char: '伤',
    pinyin: 'Shāng Mén',
    summary: '伤门：震木之怒',
    tags: ['竞争', '伤害', '冲动'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203184221.png',
    story: '早高峰的十字路口，一名脾气火爆的司机被前车逼了一下，心里那股"震木之怒"瞬间上头：方向盘一打、油门一踩，他想用速度和冲击力去"压"对方一头——这就是冲动。对方不服，两车在车流里反复别车、鸣笛、抢道，演变成赤裸裸的竞争索取：谁也不肯让一步。下一秒，轮胎打滑、车身侧撞，金属摩擦声刺耳，安全气囊炸开，人被甩得头晕眼花；救护车赶来，他手臂上留下清晰的伤疤，车也撞得支离破碎。这个场景把伤门的三段链条一次性打通：冲动一出，争夺随之，最后落到真实的伤痛与消耗。',
    coreOrigins: [
      {
        title: '核心原点 ①：竞争索取 → 抓捕、赌博与对抗',
        logic: '伤门源于震卦，当这股冲动能量主动向外施放时，就表现为竞争与索取。它代表一切带有对抗性、掠夺性的行为。',
        subItems: [
          { label: '概念', content: '抓捕、索取、赌博、打架、对抗、挑逗、渔猎、掠夺、讨债、竞争力。' },
          { label: '人物', content: '公安、军警、格斗者、斗殴者、讨债人、竞争对手。' },
          { label: '动物', content: '狮子、老虎、狗、鹰、豹子（主动攻击的猛兽）。' },
          { label: '地理', content: '公安局、检察院、法院、兵工厂。' },
        ],
      },
      {
        title: '核心原点 ②：损害消耗 → 伤痛、武器与破败',
        logic: '当冲动的能量失控或作用于自身时，便造成损害与消耗。它代表一切有形无形的伤痛、能造成伤害的武器，以及被破坏的人事物。',
        subItems: [
          { label: '概念', content: '损害、消耗、妨碍、受伤、伤心、伤痛、破败、开刀、刻薄。' },
          { label: '人物', content: '手术医生、伤心人、受伤者、遭遇事故者。' },
          { label: '形态', content: '恐惧、难看、丑陋、带伤痕。' },
          { label: '人体', content: '脚、手、肝、胆、筋、眼、伤疤、术后部位。' },
          { label: '动物', content: '蚊子、跳蚤、马蜂（刺伤、骚扰）。' },
          { label: '植物', content: '仙人掌、刺梅、荆棘、玫瑰、月季、茅草（带刺）。' },
          { label: '静物', content: '刀、剑、剪子、针、枪、炮、子弹、弓箭、锐器、炸药、武器、毒药、毒气；破裂不完整之物。' },
          { label: '地理', content: '破坏的道路、悬崖、屠宰厂、医院、化工厂、危险品存放地。' },
        ],
      },
      {
        title: '核心原点 ③：冲动 → 刚直、迅猛与暴烈',
        logic: '伤门的核心是雷厉风行的冲动能量。这股能量表现为刚直、不拐弯抹角的性格，以及迅猛、暴烈的行为方式。',
        subItems: [
          { label: '概念', content: '冲动、雷厉风行、刚直、不拐弯、爆发、急躁。' },
          { label: '人物', content: '驾驶员、行动派、冲锋者。' },
          { label: '形态', content: '威严健壮、长方脸、少笑、气势压人。' },
          { label: '性情', content: '直爽易怒、暴躁粗野、说话做事快且硬。' },
          { label: '静物', content: '汽车（速度与冲击力的象意）。' },
          { label: '方位/色彩', content: '东方；春天、早晨、风、雷电；青色、绿色。' },
        ],
      },
    ],
  },
  {
    id: 'door-du',
    char: '杜',
    pinyin: 'Dù Mén',
    summary: '杜门：幽林藏技',
    tags: ['堵塞', '想象', '技术'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203184331.png',
    story: '夜深，东南方向的风轻轻掠过窗外的绿篱，一位做保密项目的技术人员把办公室门反锁，拉上厚厚的窗帘，把外界的喧闹与目光都堵在门外——空间被隔绝，信息也被遮掩。他摊开一叠资料与书籍，在台灯下拆开一枚精密的电子芯片，一边画电路结构，一边在脑海里推演算法：越是关键的工艺，越要"杜绝外扰"，靠沉下心来钻研。电话铃忽然响起，他没有接，只把手机塞进抽屉继续专注；整晚的"堵塞与隐藏"，最终换来对核心技术的那一点"通透"。',
    coreOrigins: [
      {
        title: '核心原点 ①：堵塞 → 隔绝、关闭与隐藏',
        logic: '“杜”的本义是堵塞、断绝，代表一切物理上的阻碍、隔断和不通畅的状态。',
        subItems: [
          { label: '概念', content: '阻塞、阻止、困难、限制、闭塞、隐藏、覆盖、遮掩、关闭、断绝、抑郁。' },
          { label: '人物', content: '聋哑人、中风者。' },
          { label: '形态', content: '晦涩、呆滞、深色安然。' },
          { label: '人体', content: '呼吸系统、肝、胆、筋、血栓、循环系统不畅或被堵塞的部位。' },
          { label: '动物', content: '夜行动物（在黑暗中隐藏），如：黄鼠狼、老鼠、猫、狗、猫头鹰、蚊子。' },
          { label: '植物', content: '遮盖地皮的小草、庄稼、树木、苔藓植物。' },
          { label: '静物', content: '私房钱、门窗、瓶塞、瓶盖、衣物、被子、窗帘、内衣、胸罩。' },
          { label: '地理', content: '保护隐私的堤坝、围墙、隔离带、绿篱、通道、闸口、门槛、拥挤才会堵的闭塞之地、交通拥堵之地。' },
          { label: '方位/色彩', content: '东南方；风、空气、气流、气旋；绿色。' },
        ],
      },
      {
        title: '核心原点 ②：想象 → 意识、感觉与虚幻',
        logic: '杜门也关联精神层面的“杜绝”与“内求”，引发内在的意识活动与想象。',
        subItems: [
          { label: '概念', content: '体会到的、感觉到的、意识到的、想象到的、幻觉、虚幻、推测、vr。' },
          { label: '性情', content: '多疑、不爱言语、心平气和、文静内向。' },
          { label: '人体', content: '大脑、神经。' },
        ],
      },
      {
        title: '核心原点 ③：技术 → 保密、心法与艺技',
        logic: '为了掌握精深的技术或心法，必须杜绝外界干扰，进行保密和钻研。',
        subItems: [
          { label: '概念', content: '技术、艺技、专业技能、心法、质量（购物看）。' },
          { label: '人物', content: '技术人员、理论工作者、心理学者、管理学者、佛教徒、基督徒、从事神的工作、气功师、僧道、公检法、安全保密人员、狱警、军人。' },
          { label: '静物', content: '书籍、报刊、电子芯片。' },
        ],
      },
    ],
  },
  {
    id: 'door-jing',
    char: '景',
    pinyin: 'Jǐng Mén',
    summary: '景门：火之昭华',
    tags: ['属火', '风景', '文书'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203184439.png',
    story: '正午的南方热浪翻涌，景区门口的霓虹与灯牌在阳光里依旧耀眼，空气像被火烤得发烫。摄影团队架起灯光，镜头对准一段最上镜的山水风景，游客和一位妆容精致的"漂亮的人"一起入画，画面明亮到一切都无所遁形。拍摄间隙，一位作家/策划人坐在遮阳伞下翻开厚厚的文件，和合作方当场签下新项目合同；他把今天拍到的影像与文字素材整理成稿，准备发给媒体发布。灯光、画面、文书与信息，在"火之昭华"里汇成同一条线：景门让事物被看见、被记录、被传播，也让"热"与"炎"的气息随之而来。',
    coreOrigins: [
      {
        title: '核心原点 ①：属火 → 光明、热烈与炎症',
        logic: '景门五行属火，代表一切与火相关的光明、热烈、升腾的特性，也包括其带来的发热、发炎、烧伤等象意。',
        subItems: [
          { label: '概念', content: '火光、流血。' },
          { label: '人物', content: '烫伤者、烧伤者。' },
          { label: '性情', content: '脾气急躁。' },
          { label: '人体', content: '血液、心脏、小肠。' },
          { label: '静物', content: '灯光、烟火爆竹、霓虹灯。' },
          { label: '地理', content: '电视制作发射中心。' },
          { label: '方位/色彩', content: '南方；太阳、晴天、炎热、中午；红色、赤色。' },
        ],
      },
      {
        title: '核心原点 ②：风景 → 漂亮、艺术与景象',
        logic: '火光带来光明，使万物可见，故为“景”。这引申出一切眼睛能看到的风景、漂亮的、具有艺术美感的人事物。',
        subItems: [
          { label: '概念', content: '漂亮、风景、旅游、远景、前程。' },
          { label: '人物', content: '漂亮的人、美容美发师、美容者、旅游者、营销人、广告人、策划人、影视行业人。' },
          { label: '形态', content: '漂亮、红脸、脸尖形、身体偏瘦。' },
          { label: '动物', content: '雉鸡、孔雀、雄鹰、鸟类、观赏鱼、观赏动物等一切漂亮的生物。' },
          { label: '植物', content: '漂亮的花卉、植物、盆景。' },
          { label: '静物', content: '图画、照片、图片、艺术品、首饰、时装、颜料、油漆、美容美发用品、书画用品、电影机、电视机、投影机、海报。' },
          { label: '地理', content: '旅游景区、公园、繁华街道、电影院、戏院、各厅、美容院、娱乐场所、酒吧、歌厅。' },
        ],
      },
      {
        title: '核心原点 ③：文书 → 文化、信息与契约',
        logic: '火是文明的象征，因此“景门”也代表文化的产物，如文书、信息和知识。',
        subItems: [
          { label: '概念', content: '文化、文书。' },
          { label: '人物', content: '文化人、作家、文学家、诗人、电信类工作者、电子产品生产经营者、信息行业人、文秘、图书管理等。' },
          { label: '性情', content: '心直口快、虚心处事、知书达理。' },
          { label: '静物', content: '图书、文件、合同、证书、书籍。' },
        ],
      },
    ],
  },
  {
    id: 'door-si',
    char: '死',
    pinyin: 'Sǐ Mén',
    summary: '死门：寂土归尘',
    tags: ['死亡', '神祀', '死板固执'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203184759.png',
    story: '阴雨的西南天色压得很低，医院走廊尽头的房间长期无人出入，像一间"不住人的空房"。一位老人拄着拐杖，盯着病历上那行刺眼的字——体内的肿块已经成了难以逆转的病灶，他第一次真切感到"死门"意味着终结。回到家里，他把亲人的照片与一尊小小的神佛像摆在桌上，点香祭拜，希望彼岸能给自己或家人一点安慰。可当孩子劝他换个治疗方案、换种生活方式时，他却像上了锁一样固执：认定"就该这样"，拒绝改变，整个人越来越死板。死亡的阴影、神佛的祭祀、以及僵硬不变的心态，在同一段日子里层层叠加，正是死门的寂土归尘。',
    coreOrigins: [
      {
        title: '核心原点 ①：死亡 → 终结、病灶与凶器',
        logic: '“死”是生命活动的终点，代表一切静止、丧失活力、与死亡相关的人事物。',
        subItems: [
          { label: '概念', content: '丧失生命、没有生命、断了念头。' },
          { label: '人物', content: '故去的人、行刑之人、屠夫、救死扶伤的人。' },
          { label: '人体', content: '没有活力的部位、病灶部位、死疤、死肉、癌症、肿块、肿瘤。' },
          { label: '动物', content: '动物的尸体。' },
          { label: '植物', content: '有病的植物、干枯的植物。' },
          { label: '静物', content: '凶器（刀、枪、剑、炸弹）、绳索、枷锁、医疗器械、墓碑。' },
          { label: '地理', content: '地皮、坟墓、屠宰厂、不住人的空房、停尸间、医院、刑场。' },
        ],
      },
      {
        title: '核心原点 ②：神佛 → 祭祀、偶像与鬼神',
        logic: '由“死亡”引申出对彼岸的想象与祭拜，代表一切与神佛、鬼神、祭祀相关的偶像和器物。',
        subItems: [
          { label: '概念', content: '鬼神。' },
          { label: '静物', content: '雕塑、神佛、偶像、木偶、手办、玩具、死人照片、俑。' },
          { label: '地理', content: '玩具厂、雕塑厂。' },
        ],
      },
      {
        title: '核心原点 ③：死板 → 固执、僵化与不变',
        logic: '由物理的“死亡”引申为精神上的“僵化”，形容人或事物像死物一样执着、不灵活、拒绝变化。',
        subItems: [
          { label: '概念', content: '固定资产、执着、不灵活、没有变化、不可调和、固定不变、不可周转。' },
          { label: '人物', content: '执着的人、不灵活的人、死板的人、不能变通的人、固执的人、无药可救的人。' },
          { label: '形态', content: '脸色呆板、木纳、不灵活、死板。' },
          { label: '性情', content: '固执迟钝、稳重保守、死心眼、死气沉沉、死不认账、一条路走到黑、不灵活。' },
          { label: '动物', content: '牛、羊（性情固执）、装死、冬眠、生长缓慢的动物。' },
          { label: '植物', content: '松树、柏树等生长缓慢的树。' },
          { label: '静物', content: '锁。' },
          { label: '方位/色彩', content: '西南；云、雾、雨；灰色、黑色、蓝色。' },
        ],
      },
    ],
  },
  {
    id: 'door-jing-shock',
    char: '惊',
    pinyin: 'Jīng Mén',
    summary: '惊门：金鸣之震',
    tags: ['惊恐', '发声', '口舌是非'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203185217.png',
    story: '夜里忽然一声闷雷，窗边的风铃被震得叮当乱响，手机推送又跳出一条突发新闻，屋里的人心口一紧——先是纯粹的惊恐。第二天，闹市里音响、鞭炮、车辆喇叭交织成一片"声浪"，一位当事人被媒体围住，越解释越激动，话音越抬越高；围观者也跟着起哄，声音把情绪推到顶点。几句冲动的言辞被剪成视频传播，双方在评论区互揭短处，口舌是非迅速升级，最后干脆走进法院：律师在庭上用洪亮的发声进行辩论，对方证人被问得面色发白、瞠目结舌。惊门从"被吓到"，到"被声音点燃"，再到"被语言拉上官司"，一环扣一环。',
    coreOrigins: [
      {
        title: '核心原点 ①：惊恐 → 刺激、不安与怪异',
        logic: '“惊”的本义是因意外刺激而产生的恐惧、慌乱的心理状态。',
        subItems: [
          { label: '概念', content: '有惊无险、惊恐、奇怪、刺激、吃惊、诧异、惊慌、恐慌、忧疑。' },
          { label: '人物', content: '心律不齐之人、哮喘之人。' },
          { label: '形态', content: '瞠目结舌状、大眼睛、嘴闭不上、呆若木鸡状。' },
          { label: '性情', content: '惊恐不安、担惊受怕、忐忑不安、心事重重、心惊肉跳。' },
          { label: '人体', content: '心脏。' },
          { label: '天时', content: '雷电。' },
        ],
      },
      {
        title: '核心原点 ②：发声 → 鸣叫、音乐与响声',
        logic: '“惊”常由声音引发，故引申为一切能发声的、制造响动的人事物。',
        subItems: [
          { label: '概念', content: '声音、音乐、响声。' },
          { label: '人物', content: '歌星。' },
          { label: '性情', content: '声音宏亮。' },
          { label: '人体', content: '喉咙、声带、肺、肠。' },
          { label: '动物', content: '蝉、蛙、蝈蝈、蟋蟀、黄鹂、麻雀、等一切善于鸣叫的生物。' },
          { label: '植物', content: '白杨（沙沙）、松树（松涛阵阵）。' },
          { label: '静物', content: '风铃、钟、音响、电视、电话、钟表、乐器、鞭炮、一切能发声的物体。' },
          { label: '地理', content: '闹市、汽车噪声的街道、歌厅、影院、娱乐场所、球场、草场、乐器厂、兵工厂、炸药厂、一切能够发声的场所。' },
          { label: '方位/色彩', content: '西；白色。' },
        ],
      },
      {
        title: '核心原点 ③：口舌是非 → 辩论、官司与言辞',
        logic: '由“发声”引申为人类的言语，特别是带有辩论、争执、诉讼性质的言辞，即口舌是非。',
        subItems: [
          { label: '概念', content: '官非、口舌是非、抖讼。' },
          { label: '人物', content: '律师、教师、纪检监察人员。' },
          { label: '性情', content: '能说会道。' },
          { label: '静物', content: '残缺不全带口。' },
          { label: '地理', content: '公安局、检察院、法院。' },
        ],
      },
    ],
  },
  {
    id: 'door-kai',
    char: '开',
    pinyin: 'Kāi Mén',
    summary: '开门：乾金之门',
    tags: ['打开', '开业', '开放', '乾金'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260203184808.png',
    story: '西北方向的商务园区里，一家新公司举行剪彩仪式，负责人站在门口，先把那扇沉重的玻璃门"咔哒"一声打开，人群与灯光瞬间涌入——空间被开启，气场也被打开。大厅里挂着"开业大吉"的牌子，团队宣布新的经营计划与合作条款，正式对外开业；随后他们把会议室的墙体隔断推开，空间变得更开阔开放，客户可以自由参观流程。为了赢得信任，公司把财务与合同条款做成清晰的公开说明，必要时也能经得起审计与公示——这叫公开。仪式结束，白色与金色的奖杯、贵重设备与订单合同摆在桌上，象征乾金的权威与价值：开门一开，事业通达，名利随之。',
    coreOrigins: [
      {
        title: '核心原点 ①：打开 → 启动、行动与开启',
        logic: '象征一种具有突破性、决定性的行动，是事物从静止到启动、从闭合到开启的关键环节。',
        subItems: [
          { label: '概念', content: '手术（打开身体）、打开、学业（开启智慧）、婚嫁（开启新的人生）、驾驶（启动车辆）。' },
          { label: '人物', content: '外科医生、司机。' },
        ],
      },
      {
        title: '核心原点 ②：开业 → 事业开创与功成',
        logic: '这是开门最直接的应用，代表一切与事业、经营、财富积累和职业晋升相关的活动。',
        subItems: [
          { label: '概念', content: '经营、经济、升迁、贸易、开创、开始、庆典、谋求。' },
          { label: '人物', content: '领导、公务员、白领、名人、公司企业老板、文官、创业者、生意人。' },
          { label: '地理', content: '工作单位、店铺、门市、办公室。' },
        ],
      },
      {
        title: '核心原点 ③：开放 → 通达舒展与开朗',
        logic: '它描述了一种不受阻碍、向外舒展的状态，既可以是物理空间的，也可以是精神层面的。',
        subItems: [
          { label: '概念', content: '舒展、宽广、开放、开明、开朗、顺利、通畅、出行。' },
          { label: '性情', content: '豁达爽朗、谈吐不凡、坦诚无私、性情愉快、无所拘束、意志活跃、思想开放、通情达理、容易沟通、讲情重义、自尊心强、勤奋好学。' },
          { label: '地理', content: '高亢之地、开阔之地、飞机场、车站、码头。' },
          { label: '植物', content: '舒展的植物。' },
          { label: '天时', content: '晴空万里、天高云淡。' },
        ],
      },
      {
        title: '核心原点 ④：公开 → 官方显露与权威',
        logic: '指事物被置于公众视野之下，不再隐藏，常与官方、法律等需要透明度的领域关联。',
        subItems: [
          { label: '概念', content: '公开、暴露。' },
          { label: '人物', content: '法官、检察官。' },
          { label: '地理', content: '法院、检察院、审判庭、名人居所、公司的大门。' },
        ],
      },
      {
        title: '核心原点 ⑤：金 → 乾金之象与价值',
        logic: '开门的五行属性，源于西北乾卦，代表着权威、尊贵、财富以及一切坚固、有价值的物象。',
        subItems: [
          { label: '五行', content: '金。' },
          { label: '概念', content: '婚嫁。' },
          { label: '方位', content: '西北。' },
          { label: '色彩', content: '白色、金色。' },
          { label: '天时', content: '傍晚、秋天。' },
          { label: '人体', content: '头、肺、大肠、脊椎、骨骼。' },
          { label: '动物', content: '高贵华丽的动物（如虎、狮、豹、马、天鹅、龙）。' },
          { label: '植物', content: '高大之树、结果实的植物。' },
          { label: '静物', content: '金银饰品、贵重物品、圆形物品。' },
          { label: '地理', content: '高大建筑物、矿场。' },
        ],
      },
    ],
  },
];
